<template>
    <div id="search-page" class="bg-white">
    <div class="m-3 pt-3 flex" >
        <a-breadcrumb separator=">">
            <a-breadcrumb-item href="/home">
                <router-link
                    :to="`/`"
                >
                    Home
                </router-link>
            </a-breadcrumb-item>
            <a-breadcrumb-item v-if="levels_name !== 'false'" v-bind:href="`/levels/${this.levels_id}/${encodeUrl(levels_name)}`">
             <router-link 
                    :to="`/levels/${this.levels_id}/${encodeUrl(levels_name)}`"
             >
                {{this.levels_name}}
            </router-link>
            </a-breadcrumb-item>
            

            <a-breadcrumb-item v-for="(father, index) in levels_fathers" 
                :key="index"  v-bind:href="`/itens/${father.id}/${encodeUrl(father.name)}`">
                <a
                    :href="`/itens/${father.id}/${encodeUrl(father.name)}`"
                >
                    {{father.name}}
                </a>
            </a-breadcrumb-item>
        </a-breadcrumb>


        <a-input-search v-model="filter" placeholder="Buscar na pasta" id="busca" style="width: 300px; " @change="onChange" />
    </div>
        
        <div
            v-if="hasSons"
        >
            <h4 class="fab-home">Sub Pastas</h4>
            <a-table :columns="columns" :data-source="levels_sons" :locale="locale" >
                <span slot="name" slot-scope="text, record">
                    <svg
                        width="24"
                        height="19"
                        viewBox="0 0 24 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M10.308 0.700625C9.852 0.249375 9.24 0 8.604 0H2.4C1.08 0 0.012 1.06875 0.012 2.375L0 16.625C0 17.9312 1.08 19 2.4 19H21.6C22.92 19 24 17.9312 24 16.625V4.75C24 3.44375 22.92 2.375 21.6 2.375H12L10.308 0.700625Z"
                            fill="#FAC782"
                        />
                    </svg>

                    <strong>
                         <a :href="`/itens/${record.acervo_id}/${encodeUrl(record.name)}`"
                            class="fab-table-nome" >{{ text }}</a>
                    </strong>
                </span>

                <span slot="creator" class="fab-text-capitalize" slot-scope="text">
                    {{text}}
                </span>

                <template slot="acao" slot-scope="text, record">
                    <a>
                        <a-icon :theme="`${record.favorite ? 'filled' : 'outlined'}`" type="star" style="fontSize:20px;" @click="showModal(record.acervo_id, record.name)" />
                    </a>
                </template>
            </a-table>
        </div>
        <div
            v-if="hasLevelsItens"
        >
            <a-table :columns="columns" :data-source="levels_itens" :locale="locale" >
                <span slot="name" slot-scope="text, record">
                    <a-icon
                        class="mr-3"
                        :style="`fontSize:20px;color:${checkColor(record)};`"
                        :type="checkType(record)"
                        theme="filled"
                    />
                    <strong>
                        <router-link :to="`/documents/${record.acervo_id}`" class="fab-table-nome">{{ text }}</router-link>
                    </strong>
                </span>

                <span slot="creator" class="fab-text-capitalize" slot-scope="text">
                    {{text}}
                </span>

                <template slot="acao" slot-scope="text, record">
                    <a>
                        <a-icon :theme="`${record.favorite ? 'filled' : 'outlined'}`" type="star" style="fontSize:20px;" @click="showModal(record.acervo_id, record.name)" />
                    </a>
                </template>
            </a-table>
        </div>
        <div class="vx-row mt-4 md:flex-row flex-col-reverse mt-6"
            v-if="!hasLevelsItens">
            <h4>Carregando dados...</h4>
        </div>
        <div>
            <a-modal v-model="visible" title="Lista de favoritos" @ok="handleOk" okText="Favoritar" cancelText="Cancelar">
                <h6>Favoritar: {{this.modal_name_document}}</h6>
                <div  v-for="(item, index) in favoriteListOption"
                    :key="index" :class="`${modal_id_favorite == item.id || checkFavoriteExists(item.id) ? 'bg-gray' : ''}`"
                    @click="selectFavoriteId(item.id)"
                >
                    <p  >
                        {{item.name}}
                    </p>
                </div>

            </a-modal>
        </div>
    </div>
</template>

<script>
import { videoPlayer } from "vue-video-player";
import "video.js/dist/video-js.css";
import { sync, call } from "vuex-pathify";

const columns = [
    {
        title: "Titulo",
        dataIndex: "name",
        key: "name",
        scopedSlots: { customRender: "name" }
    },
    {
        title: "Criador",
        dataIndex: "creator",
        key: "creator",
        scopedSlots: { customRender: "creator" }
    },
    {
        title: "",
        dataIndex: "acao",
        scopedSlots: { customRender: "acao" }
    }
];
export default {
    async mounted() {
        await this.getItens({id: this.$route.params.id, name:  this.$route.params.name});
        await this.GetLevelFather({id: this.$route.params.id}); 
    },
    data() {
        return {
            filter: '',
            visible: false,
            columns,
            favoriteListId: "",
            selectedDocuments: [],
            modal_id_document: false,
            modal_name_document: '',
            modal_id_favorite: false,
            locale: { emptyText: "Nenhum resultado foi encontrado" },
        };
    },
    watch: {

    },
    computed: {
        ...sync([
            "search/levels_sons",
            "search/levels_id",
            "search/levels_name",
            "search/levels_fathers",
            "search/levels_itens",
            "search/favorite_list_ids",
            "favoriteList/favoriteListOption"
        ]),
        hasLevelsItens() {
            if (this.levels_itens === undefined) {
                this.$vs.notify({
                    title: "Alerta",
                    text:
                        "Nenhum arquivo foi encontrado para esta pasta",
                    color: "warning",
                    iconPack: "feather",
                    icon: "icon-alert-circle"
                });
            }
            return this.levels_itens !== false ? true : false ;
        },
        hasSons() {
            return this.levels_sons.length;
        }
    },
    methods: {
        ...call({
            getItens: "search/getItens",
            GetLevelFather: "search/GetLevelFather",
            getFavoritesUserIdList: "search/getFavoritesUserIdList",
            addDocumentFavoriteList:
                "documentsFavoriteLists/addDocumentFavoriteList",
        }),
        checkType(record) {
            if (record.type == '') {
                return 'file';
            }
            if (record.type == 'document') {
                return 'file';
            }
            if (record.type == 'video') {
                return 'play-circle';
            }
            if (record.type == 'audio') {
                return 'sound';
            }
            if (record.type == 'image') {
                return 'file-image';
            }
            if(!record.type) {
                return 'folder';
            }
            return '';
        },
        checkColor(record) {
            if (record.type == 'image') {
                return 'blue';
            }
            if (record.type == 'document') {
                return 'blue';
            }
            if (record.type == 'video') {
                return 'red';
            }
            if (record.type == 'audio') {
                return 'green';
            }
            return 'blue';
        },
        onChange (e) {
            const filter_itens = this.levels_itens.filter(itens => itens.name.toLocaleLowerCase().startsWith(this.filter.toLocaleLowerCase()))
            if (!filter_itens.length) {
                this.$vs.notify({
                    title: "Erro",
                    text:
                        "Nenhuma pasta foi encontrada com esta busca.",
                    color: "danger",
                    iconPack: "feather",
                    icon: "icon-alert-circle"
                });
                this.getItens({id: this.$route.params.id, name:  this.$route.params.name});
                return false;
            }
            if (this.filter.length == 0) {
                this.getItens({id: this.$route.params.id, name:  this.$route.params.name});
            }
            this.levels_itens = filter_itens;
        },
        checkFavoriteExists(id){
            return this.favorite_list_ids.includes(parseInt(id));
        },
        showModal(id, name) {
            this.visible = true;
            this.modal_id_document = id;
            this.modal_name_document = name;
            this.selectedDocuments = id;

            this.getFavoritesUserIdList({id});
        },
        handleOk() {
            this.addDocument();
            this.visible = false;
            this.modal_id_document = false;
            this.modal_name_document = '';
        },
        selectFavoriteId(id) {
            this.modal_id_favorite = id;
            this.favoriteListId = id;
        },
        async addDocument() {
            this.$vs.loading();
            try {
                await this.addDocumentFavoriteList({
                    favoriteListId: this.favoriteListId,
                    documentsIds: this.selectedDocuments,
                });

                this.$vs.loading.close();
                this.$vs.notify({
                    title: "Documento Adicionado!",
                    text:
                        "Documento adicionado a lista de favoritos com sucesso!",
                    color: "success",
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                });

                this.favoriteListId = "";
            } catch (error) {
                this.$vs.loading.close();
                this.$vs.notify({
                    title: "Erro!",
                    text: error.message,
                    color: "danger",
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                });
            }
        this.modal_id_favorite = false;
        },
        encodeUrl(url) {
            return encodeURIComponent(url);
        }
    },
    components: {
        videoPlayer,
    }
};
</script>

<style lang="scss">
    @import "@/assets/scss/vuesax/pages/search.scss";
    .flex {
        display: flex;
        justify-content: space-between;
    }
    .ant-input {
        border-radius:50px;
        border:1px solid rgb(204, 202, 202);
        color:black;

    }
    em {
        background-color: yellow;
    }

    .search-Page__search-result {
        .request-new-permission-container {
            display: none;
        }

        &:hover .request-new-permission-container {
            display: inline-block;
        }
    }
    .fab-titulo {
        font-size: 14px !important;
        color: #292B35 !important;
        margin-top: 3px;
        text-decoration: none;
    }

    .btn-favorite {
        margin: 10px auto;
    }

    .fab-home {
        color: #106afe;
        padding: 10px;
        padding-top: 15px;
    }
    .fab-series {
        padding: 10px 10px 10px 0px;
    }
    .fab-series-item {
        padding: 5px;
        display: flex;
        margin: 20px;
        border: 1px solid rgb(204, 202, 202);
        border-radius: 5px;
    }
    .fab-ultimos-acessos {
        padding: 10px 10px 10px 0px;
    }
    .fab-badge {
        font-size: 10px;
        margin-left: 5px;
        background-color: rgb(204, 202, 202);
        padding: 5px 10px 5px 10px;
        border-radius: 10px;
    }
    .fab-series-item-texto {
        display: flex;
        flex-direction: column;
    }
    .fab-table-nome {
        margin-left: 7px;
        font-size: 16px !important;
        color: #292B35 !important;
        text-decoration: none;
    }
    .fab-text-capitalize {
        text-transform: capitalize;
    }
    .bg-gray {
        background-color: rgb(204, 202, 202);
    }
</style>

